import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/global.css";
import I18nMixin from "./i18n";

Vue.config.productionTip = false;
Vue.mixin(I18nMixin);

Vue.directive("reveal", {
  inserted(el) {
    el.classList.add("reveal-on-scroll");

    const siblings = Array.from(el.parentNode ? el.parentNode.children : []);
    const revealSiblings = siblings.filter((node) => node.classList && node.classList.contains("reveal-on-scroll"));
    const revealIndex = Math.max(revealSiblings.indexOf(el), 0);
    const stagger = Math.min(revealIndex * 160, 720);

    el.style.setProperty("--reveal-delay", `${stagger}ms`);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("is-visible");
            observer.unobserve(el);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    observer.observe(el);
    el.__revealObserver__ = observer;
  },
  unbind(el) {
    if (el.__revealObserver__) {
      el.__revealObserver__.disconnect();
      delete el.__revealObserver__;
    }
  }
});

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
